import React from 'react';
import { motion } from 'framer-motion';

const skills = [
  { name: 'React', level: 95 },
  { name: 'TypeScript', level: 90 },
  { name: 'Node.js', level: 88 },
  { name: 'GraphQL', level: 85 },
  { name: 'Docker', level: 80 },
  { name: 'AWS', level: 75 },
  { name: 'CI/CD', level: 90 },
  { name: 'AI/ML', level: 80 },
  { name: 'Open Source', level: 95 },
  { name: 'Python', level: 82 },
  { name: 'Go', level: 70 },
  { name: 'Microservices', level: 85 },
  { name: 'Three.js', level: 78 },
  { name: 'Storybook', level: 80 },
  { name: 'MongoDB', level: 75 },
  { name: 'Express.js', level: 80 },
  { name: 'PostgreSQL', level: 70 },
  { name: 'REST APIs', level: 90 },
  { name: 'Next.js', level: 85 }
];

const SkillsVisualization = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-slate-900">Skills & Expertise</h2>
          <p className="text-slate-500 mt-2">A snapshot of technologies and tools I use to build robust solutions.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-6">
            {skills.slice(0, Math.ceil(skills.length / 2)).map((skill, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: i * 0.08 }} className="bg-white p-4 rounded-lg shadow-sm border border-slate-100">
                <div className="flex items-center justify-between">
                  <div className="text-slate-800 font-medium">{skill.name}</div>
                  <div className="text-sm text-slate-500">{skill.level}%</div>
                </div>
                <div className="w-full h-3 bg-slate-100 rounded-full mt-3 overflow-hidden">
                  <motion.div initial={{ width: 0 }} whileInView={{ width: `${skill.level}%` }} transition={{ duration: 1.2, ease: 'easeOut' }} className="h-3 bg-gradient-to-r from-blue-500 to-indigo-500" />
                </div>
              </motion.div>
            ))}
          </div>

          <div className="space-y-6">
            {skills.slice(Math.ceil(skills.length / 2)).map((skill, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: i * 0.08 }} className="bg-white p-4 rounded-lg shadow-sm border border-slate-100">
                <div className="flex items-center justify-between">
                  <div className="text-slate-800 font-medium">{skill.name}</div>
                  <div className="text-sm text-slate-500">{skill.level}%</div>
                </div>
                <div className="w-full h-3 bg-slate-100 rounded-full mt-3 overflow-hidden">
                  <motion.div initial={{ width: 0 }} whileInView={{ width: `${skill.level}%` }} transition={{ duration: 1.2, ease: 'easeOut' }} className="h-3 bg-gradient-to-r from-pink-500 to-rose-500" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center text-slate-600">If you'd like to see detailed examples of my work with these technologies, check out the portfolio section.</div>
      </div>
    </section>
  );
};

export default SkillsVisualization;
